import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-gender-selector.html';
import '../ns-radio-button/ns-radio-button.html'

/**
 * The ns-gender-selector should be used to allow a user to indicate gender.
 * <br />It toggles between two distinct choices:
 * <ul>
 *     <li>Male</li>
 *     <li>Female</li>
 * </ul>
 * <h1>Gender Selector</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-gender-selector></ns-gender-selector>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsGenderSelector extends PolymerElement {
    constructor() {
        super();
    }

    static get is() {
        return "ns-gender-selector";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    static get properties() {
        return {
            /**
             * id is used to target the gender selector block of code specifically
             */
            id: String,
            /**
             * title is used to display the title of the section. By default, it is "Gender"
             */
            title: {
                type: String,
                value: "Gender"
            },
            /**
             * male is used by default for both the value and the label
             */
            male: {
                type: String,
                value: "Male"
            },
            /**
             * female is used by default for both the value and the label
             */
            female: {
                type: String,
                value: "Female"
            }
        };
    }

    ready() {
        super.ready();
        var title = this.$.genderSelectorTitle;
        console.log('in gender selector ready:', title);
    }

    toggleRadio(e) {
        var nameGroup = this.$.radioButtons.children;
        for(var i = 0; i < nameGroup.length; i++) {
            nameGroup[i].checked = false;
        }
        this.checked = true;
    }

}
customElements.define(NsGenderSelector.is, NsGenderSelector);
